/* eslint-disable react/no-multi-comp */
import React from 'react'
import styled from 'react-emotion'
import { useSelector } from 'react-redux'

import HiddenFields from 'components/integrations/HiddenFields'

import {
  selectGitHubHiddenFields,
  selectGitHubNodesById,
  selectGitHubVisibleFields,
} from 'ducks/integrations/github'
import themeVars from 'ui_theme/site/globals/site.variables'
import { Icon } from 'util/ui'

import LinkedResourceActions from 'components/integrations/LinkedResourceActions'
import LinkedGitHubIssueFields from './LinkedGitHubIssueFields'
import { useGitHubIssueActions } from './hooks'

export default styled(LinkedGitHubIssue)`
  .icon {
    font-size: ${themeVars.tiny};
    color: ${themeVars.ultraLight};
    cursor: pointer;
    margin-right: ${themeVars.mini};
    line-height: ${themeVars.small};
  }

  a .icon {
    color: inherit;
  }

  .LinkedGitHubIssue-title {
    font-size: ${themeVars.small};
    font-weight: ${themeVars.graphikWeightMedium};
  }
`

function LinkedGitHubIssue({
  className,
  doNavigatableClearState,
  navigatableState: issueId,
}) {
  const issue = useSelector(selectGitHubNodesById)[issueId]
  const hiddenFields = useSelector(selectGitHubHiddenFields)
  const visibleFields = useSelector(selectGitHubVisibleFields)
  const actions = useGitHubIssueActions(issue, doNavigatableClearState)
  const { id, title } = issue || {}

  if (!issue) return null
  return (
    <div className={className}>
      <div className="LinkedGitHubIssue-title">
        <Icon name="chevron left" onClick={doNavigatableClearState} />
        {title}
      </div>

      {visibleFields &&
        visibleFields.length > 0 && (
          <LinkedGitHubIssueFields fields={visibleFields} issue={issue} />
        )}
      <LinkedResourceActions id={id} actions={actions} />

      {hiddenFields &&
        hiddenFields.length > 0 && (
          <HiddenFields initiallyShown={false}>
            <LinkedGitHubIssueFields fields={hiddenFields} issue={issue} />
          </HiddenFields>
        )}
    </div>
  )
}
